import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { AccessButton } from "iuvity-ui-components";

interface SettingsUsedProps {
  title: string;
  data: any;
};

export const SettingsUsed: React.FC<SettingsUsedProps> = ({
  title,
  data
}) => {
  const {
    t,
  } = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <div className="settings-container">
      <div className="title">
        {title}
      </div>
      <div className="card-container">
        {data?.slice(0,5)?.map((item: any) => (
          <a 
            className="card-content" 
            key={item.id} 
            href={item.isexternallink && item.linkto}
            target={item.isexternallink && '_blank'}
            onClick={() =>  item.isexternallink === false && navigate(item.linkto)} 
          >
            <AccessButton
              icon={item.iconname}
              id={item.id}
              label={t(`Quicklinks.${item.labelkey}`)}
              iconPosition="top"
            />
          </a>
        ))}
      </div>
    </div>
  );
};
